import React, { useState, useEffect, useRef } from "react";
import usePutData from "../../repo/put";
import GoogleDriveImage from "./GoogleDriveImage";
import AbrirPDFPopup from "./AbrirPDFPopup";
import DeleteButton from "./DeleteButton";
import HistoricosComponent from "./Historicos";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import useFetchData from "../../repo/get";
import { ProgressSpinner } from 'primereact/progressspinner';
export default function FichaDetails({ ficha, onClose }) {
  const toast = useRef(null);
  const { data: fetchedData, isLoading, error } = useFetchData(
    `api/romaneios/findBySearch/${ficha}`
  );
  const { putData } = usePutData();

  const [detailsData, setDetailsData] = useState(null);
  const [showOcorrenciaDialog, setShowOcorrenciaDialog] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);

  // Sincroniza fetchedData no state local
  useEffect(() => {
    if (fetchedData) {
      setDetailsData(fetchedData);
    }
  }, [fetchedData]);

  const notify = ({ severity, summary, detail }) => {
    toast.current?.show({ severity, summary, detail, life: 3000 });
  };

  const handleConfirm = async () => {
    setIsUpdating(true);
    try {
      const response = await putData(
        `api/romaneios/update/codigo/${ficha}`,
        { status: "finalizado" }
      );
      if (response?.message) {
        throw new Error(response.message);
      }
      notify({ severity: "success", summary: "Sucesso", detail: "Status finalizado!" });
      await handleVerify();
    } catch (err) {
      notify({ severity: "error", summary: "Erro", detail: err.message });
    } finally {
      setIsUpdating(false);
      setShowOcorrenciaDialog(false);
    }
  };

  const handleVerify = async () => {
    setIsVerifying(true);
    const token = localStorage.getItem("accessToken");
    try {
      const res = await fetch(
        `https://getapi.lc-transportes.com/api/romaneios/isFinished/${ficha}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!res.ok) {
        throw new Error(`Status ${res.status}`);
      }
      const updated = await res.json();
      setDetailsData(updated);
      notify({ severity: "success", summary: "Atualizado", detail: "Dados atualizados." });
    } catch (err) {
      notify({ severity: "error", summary: "Erro na verificação", detail: err.toString() });
    } finally {
      setIsVerifying(false);
    }
  };

  if (isLoading || !detailsData) {
    return <p><strong>Carregando detalhes da ficha...</strong></p>;
  }
  if (error) {
    return <p><strong>Ficha não encontrada.</strong></p>;
  }

  const DetailRow = ({ label, value }) =>
    value ? (
      <p>
        <strong>{label}:</strong> {value}
      </p>
    ) : null;

  const hn = (v, def = "Não informado") => v ?? def;
  const fd = detailsData;

  const formatted = {
    ...fd,
    codigodeficha: hn(fd.codigoUid),
    horaedia: hn(fd.data).replace("T", " ").split(".")[0],
    empresa: hn(fd.empresa?.nome),
    entregador: hn(fd.entregador?.nome),
    motorista: hn(fd.motorista?.nome),
    funcionario: hn(fd.funcionario?.nome),
    entregadortelefone: hn(fd.entregador?.telefone),
    motoristatelefone: hn(fd.motorista?.telefone),
    entregadorendereco: hn(fd.entregador?.endereco),
    local: Array.isArray(fd.cidade)
      ? fd.cidade.map(c => hn(c.nome)).join(", ")
      : "Não informado",
    status: hn(fd.sts),
    codigos: Array.isArray(fd.codigos) ? fd.codigos : [],
    linkDownload: hn(fd.linkDownload),
    base: hn(fd.base?.nome),
    linkImagem: hn(fd.linkDownloadImg),
    dataFinal: fd.dataFinal ? fd.dataFinal.replace("T", " ").split(".")[0] : "Não informado",
  };

  return (
    <>
      <Toast ref={toast} />

      <Dialog
        header="Detalhes da Ocorrência"
        visible={showOcorrenciaDialog}
        style={{ width: "50%", maxWidth: "600px" }}
        onHide={() => setShowOcorrenciaDialog(false)}
        footer={
          <div className="flex justify-end space-x-4">
            {formatted.status !== "finalizado" ? (
              <>
                <Button
                  label="Cancelar"
                  icon="pi pi-times"
                  className="bg-red-500 text-white px-3 py-1 rounded-md shadow"
                  onClick={() => setShowOcorrenciaDialog(false)}
                />
                <Button
                  label={isUpdating ? "Atualizando..." : "Confirmar"}
                  icon="pi pi-check"
                  className="bg-emerald-500 text-white px-3 py-1 rounded-md shadow"
                  onClick={handleConfirm}
                  disabled={isUpdating}
                />
              </>
            ) : (
              <Button
                label="Fechar"
                icon="pi pi-times"
                className="bg-red-500 text-white px-3 py-1 rounded-md shadow"
                onClick={() => setShowOcorrenciaDialog(false)}
              />
            )}
          </div>
        }
      >
        <p className="text-gray-700">{fd.ocorrencia || "Nenhuma ocorrência."}</p>
      </Dialog>

      <div className="flex flex-col md:flex-row justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-blueGray-700">
          {formatted.codigodeficha}
        </h2>
        <div className="flex space-x-2">
          {fd.ocorrencia && (
            <Button
              label="Ocorrência"
              icon="fa fa-life-ring"
              className="bg-orange-500 text-white px-3 py-1 rounded-md shadow"
              onClick={() => setShowOcorrenciaDialog(true)}
            />
          )}
          <AbrirPDFPopup link={formatted.linkDownload} />
          <HistoricosComponent formattedDetails={formatted} />
          {formatted.linkImagem !== "Não informado" && (
            <Button
              label="Imagem"
              icon="pi pi-image"
              className="bg-emerald-500 text-white px-3 py-1 rounded-md shadow"
              onClick={() => window.open(formatted.linkImagem, "_blank")}
            />
          )}
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-start justify-between mt-8">
        <div className="min-w-0 break-words mb-6 shadow-lg rounded-lg bg-white p-6 w-full md:w-3/5">
          <DetailRow label="Base" value={formatted.base} />
          <DetailRow label="Funcionário" value={formatted.funcionario} />
          <DetailRow label="Data" value={formatted.horaedia} />
          {formatted.status !== "aguardando" && formatted.status !== "alocado" && (
            <DetailRow
              label="Data de retirada"
              value={
                fd.dataRetirado
                  ? fd.dataRetirado.replace("T", " ").split(".")[0]
                  : formatted.horaedia
              }
            />
          )}
          {formatted.status === "finalizado" && (
            <DetailRow label="Data de finalização" value={formatted.dataFinal} />
          )}
          <DetailRow label="Quantidade" value={formatted.quantidade} />
          <DetailRow label="Empresa" value={formatted.empresa} />
          {formatted.status !== "aguardando" && (
            <>
              <DetailRow label="Motorista" value={formatted.motorista} />
              <DetailRow label="Telefone do motorista" value={formatted.motoristatelefone} />
            </>
          )}
          <DetailRow label="Entregador" value={formatted.entregador} />
          <DetailRow label="Endereço" value={formatted.entregadorendereco} />
          <DetailRow label="Telefone do entregador" value={formatted.entregadortelefone} />
          <DetailRow label="Cidade" value={formatted.local} />
          <DetailRow label="Status" value={formatted.status} />

        </div>
        <div className="flex justify-center">
          {formatted.linkImagem === "Não informado" ? (
            <QRCodeCanvas value={formatted.codigodeficha} size={256} />
          ) : (
            <GoogleDriveImage driveLink={formatted.linkImagem} />
          )}
        </div>

      </div>


      <div className="bg-white p-6 rounded-lg shadow mb-6">
        <p><strong>Códigos Inseridos:</strong></p>
        <div className="flex">
          <ul className="list-disc pl-5 flex-1">
            {formatted.codigos.map((item, i) => {
              const raw = typeof item === "string" ? item : item.codigo ?? "Inválido";
              const status = item.sts ?? "";
              console.log(status);
              let color = "rgb(125,125,125)";
              if (status === "finalizado") color = "rgb(70,183,53)";
              if (status === "recusado") color = "rgba(255,0,0,0.8)";
              if (status === "atrasado") color = "rgb(255,141,41)";
              if (status === "devolvido") color = "rgba(224,0,138,0.8)";
              if (status === "retirado") color = "rgb(16,119,255)";
              const label = item.type === "CAIXAS" ? `CAIXA - ${raw}` : `PACOTE - ${raw}`;
              return (
                <>
                  <li
                    key={i}
                    className="custom-marker text-sm text-gray-700"
                    style={{ '--marker-color': color }}
                  >
                    {label}
                  </li>
                </>

              );
            })}
          </ul>
          {/* legenda aqui, igual ao seu código original */}
          {/* Legenda de cores */}
          <div className="flex flex-col justify-end pl-5">
            <div className="flex items-center justify-end text-gray-700">
              <span>Devolvidosㅤ</span>
              <div
                style={{
                  width: "32px",
                  height: "22px",
                  backgroundColor: "rgba(81, 0, 255, 0.81)",
                }}
              />
            </div>
            <div className="flex items-center justify-end text-gray-700">
              <span>Trativaㅤ</span>
              <div
                style={{
                  width: "32px",
                  height: "22px",
                  backgroundColor: "rgba(224, 0, 138, 0.81)",
                }}
              />
            </div>
            <div className="flex items-center justify-end text-gray-700">
              <span>Recusadosㅤ</span>
              <div
                style={{
                  width: "32px",
                  height: "22px",
                  backgroundColor: "rgba(255, 0, 0, 0.81)",
                }}
              />
            </div>
            <div className="flex items-center justify-end text-gray-700">
              <span>Atrasadoㅤ</span>
              <div
                style={{
                  width: "32px",
                  height: "22px",
                  backgroundColor: "rgb(255, 141, 41)",
                }}
              />
            </div>
            <div className="flex items-center justify-end text-gray-700">
              <span>Entreguesㅤ</span>
              <div
                style={{
                  width: "32px",
                  height: "22px",
                  backgroundColor: "rgb(70, 183, 53)",
                }}
              />
            </div>
            <div className="flex items-center justify-end text-gray-700">
              <span>Na Ruaㅤ</span>
              <div
                style={{
                  width: "32px",
                  height: "22px",
                  backgroundColor: "rgb(16, 119, 255)",
                }}
              />
            </div>
            <div className="flex items-center justify-end text-gray-700">
              <span>Em Baseㅤ</span>
              <div
                style={{
                  width: "32px",
                  height: "22px",
                  backgroundColor: "rgb(125, 125, 125)",
                }}
              />
            </div>
          </div>
        </div>
        {isVerifying && (
        <div className="fixed inset-0 bg-opacity-40 flex items-center justify-center z-50">
          <ProgressSpinner
            style={{ width: '50px', height: '50px' }}
            strokeWidth="8"
            fill="var(--surface-ground)"
            animationDuration=".5s"
          />
        </div>
      )}
      </div >

      {
        localStorage.getItem("cargo") === "ADMIN" && (
          <div className="flex justify-end space-x-2">
            <DeleteButton
              cargo="romaneio"
              data="romaneios/deleteById/"
              userId={formatted.id}
              onDeleteSuccess={() => window.location.reload()}
            />
            <Button
              label={isVerifying ? "Verificando..." : "Verificar"}
              icon="pi pi-search"
              className="bg-blue-500 text-white px-3 py-1 rounded-md shadow"
              onClick={handleVerify}
              disabled={isVerifying}
            />
          </div>
        )
      }
    </>
  );
}
